import { Spinner } from "react-bootstrap";

const Loader = ({ animation = "border", size="lg", variant="dark" ,istext=""}) => {
  

  return (
    <div style={{display:"flex", justifyContent:"center", alignItems:"center" ,gap:"10px"}}>
  <Spinner animation={animation} variant={variant} size={size} /><p>{istext}</p>
    </div>
    
    
  );
};

export default Loader;
